import React, { useEffect, useState } from "react";
import { Form } from "antd";
import PropertyTypesAdmin from "../../components/PropertyTypesAdmin/PropertyTypesAdmin";
import { fetchPropertyPageSearchTypes } from "../../store/slices/property-type-admin";
import {
  fetchDicDataType,
  fetchDicMultiplType,
  fetchDicRequiredType,
} from "../../store/slices/rtkDictionaries";
import { useAppDispatch, useAppSelector } from "../..";
import { PropertyTypeSearchParams } from "../../lib/interfaces";
import { fetchDictionaryTypes } from "../../store/slices/dicts";

const PropertyTypesAdminContainer = () => {
  const dispatch = useAppDispatch();
  const [editStatus, setEditStatus] = useState<"" | "editingForce" | "deleteForce">("");
  const [form] = Form.useForm();
  const [formFilters] = Form.useForm();
  const defaultPropertyTypeSearchParams: PropertyTypeSearchParams = {
    page: 0,
    size: 20,
    sort: ["object_type_id,asc", "id,asc", "tenantId,desc"],
    objectTypeSysname: "",
    propertyTypeAlias: "",
    name: "",
  };
  const [propertyTypeSearchParams, setPropertyTypeSearchParams] = useState(
    defaultPropertyTypeSearchParams
  );
  const { propertyPageSearchTypes, propertyPageSearchTypesLoading } = useAppSelector(
    (state) => state.propertyTypesAdmin
  );

  useEffect(() => {
    dispatch(fetchPropertyPageSearchTypes(defaultPropertyTypeSearchParams));
    setEditStatus("");
    dispatch(fetchDicDataType());
    dispatch(fetchDicRequiredType());
    dispatch(fetchDicMultiplType());
    dispatch(fetchDictionaryTypes());
  }, []);

  const getValuePropertyType = (field) => propertyTypeSearchParams[field];

  const handlePageSize = (field: "size" | "page", value: number) => {
    switch (field) {
      case "size":
        setPropertyTypeSearchParams({ ...propertyTypeSearchParams, size: value, page: 0 });
        dispatch(
          fetchPropertyPageSearchTypes({ ...propertyTypeSearchParams, size: value, page: 0 })
        );
        break;
      case "page":
        setPropertyTypeSearchParams({ ...propertyTypeSearchParams, page: value - 1 });
        dispatch(fetchPropertyPageSearchTypes({ ...propertyTypeSearchParams, page: value - 1 }));
        break;
      default:
        break;
    }
  };

  const handleSearch = (values: PropertyTypeSearchParams) => {
    setEditStatus("");
    setPropertyTypeSearchParams(values);
    dispatch(fetchPropertyPageSearchTypes(values));
  };

  const resetSearchPayments = () => {
    formFilters.resetFields();
    setPropertyTypeSearchParams(defaultPropertyTypeSearchParams);
    dispatch(fetchPropertyPageSearchTypes(defaultPropertyTypeSearchParams));
  };

  return (
    <>
      <div className="container_height">
        <PropertyTypesAdmin
          form={form}
          formFilters={formFilters}
          propertyPageSearchTypes={propertyPageSearchTypes}
          propertyPageSearchTypesLoading={propertyPageSearchTypesLoading}
          handlePageSize={handlePageSize}
          defaultPropertyTypeSearchParams={defaultPropertyTypeSearchParams}
          resetSearchPayments={resetSearchPayments}
          getValuePropertyType={getValuePropertyType}
          handleSearch={handleSearch}
          setEditStatus={setEditStatus}
          editStatus={editStatus}
          propertyTypeSearchParams={propertyTypeSearchParams}
        />
      </div>
    </>
  );
};

export default PropertyTypesAdminContainer;
